import React, { useEffect, useState, useRef } from 'react';
import { SideSheet, PointsBatch } from '@desquared/wave-components-library';
import { PointsSideSheetStore } from '@/store/sideSheet';
import { formatNumber } from '@/utils/amountUtils';
import { useTranslations } from 'next-intl';

export default function PointsAside({
  firstName,
  lastName,
  userPoints,
  pointsSteps,
  onSelectPoints,
  onConfirmRedemption,
  onClearRedemption,
  onClose,
}) {
  const [sideSheet, setSideSheet] = useState(false);
  const refOne = useRef(null);
  const t = useTranslations('common.asides.points');

  const closeSheet = () => {
    setTimeout(() => {
      PointsSideSheetStore.close();
    }, '300');
  };
  useEffect(() => {
    const PointsSideSheetStore$ = PointsSideSheetStore.subscribe(setSideSheet);

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      PointsSideSheetStore$.unsubscribe();

      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = e => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      PointsSideSheetStore.close();
    }
  };

  if (!sideSheet) return null;
  return (
    <div ref={refOne}>
      <SideSheet
        header={t('header')}
        hasClose={true}
        onClose={() => {
          closeSheet();
          onClose();
        }}
        buttonText={t('btn_text')}
        onSubmit={() => {
          onConfirmRedemption();
          closeSheet();
        }}
        cancelButtonText={t('clear_btn')}
        onCancel={onClearRedemption}
      >
        <PointsBatch
          greetingText={t('greeting')}
          firstName={firstName}
          lastName={lastName}
          points={formatNumber(userPoints)}
          steps={pointsSteps}
          hasPic={false}
          onSelectPoints={onSelectPoints}
          heading={t('heading')}
          pointsLabel={t('points_label')}
        />
      </SideSheet>
    </div>
  );
}
